import axios from "axios";
import { useSetRecoilState } from "recoil";
import { displayLinkState } from "Recoil/Checkins/atom";

export const usePreviewLink = () => {
  const setDisplayLinkState = useSetRecoilState(displayLinkState);
  const getLinkDetails = async (url, name, setValue) => {
    try {
      if (process.env.REACT_APP_PREVIEW_LINK && url) {
        setDisplayLinkState({ loading: true });
        const updatedURL = `https://api.linkpreview.net/?key=${process.env.REACT_APP_PREVIEW_LINK}&q=${url}`;
        const response = await axios.get(updatedURL);
        response.url = url;
        setDisplayLinkState(response.data);
        name && setValue(`${name}.viewLink`, response.data);
      }
    } catch (error) {
      console.log("Error", error);
      setDisplayLinkState({ loading: false });
      return {};
    }
  };

  return {
    getLinkDetails
  };
};
